module.exports = __webpack_public_path__ + "img/form.c82ed8f.webp";